/**
 * Utilities for React Native WebView integration.
 *
 * When Delivery OS is loaded inside a React Native WebView,
 * the app injects auth data into window.woltPartnerAuth before loading the page.
 */

export type WoltPartnerAuth = {
  accessToken: string;
};

// Extend Window interface to include injected auth data from React Native WebView
declare global {
  interface Window {
    woltPartnerAuth?: WoltPartnerAuth;
  }
}

/**
 * Check if the app is running inside a React Native WebView
 * by checking for the presence of injected auth data.
 */
export const isRunningInPartnerApp = (): boolean =>
  typeof window !== 'undefined' && !!window.woltPartnerAuth?.accessToken;

// Get the injected auth data from the WebView.
export const getPartnerAuth = (): WoltPartnerAuth | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.woltPartnerAuth;
};
